
(()=> {
  const initialize=(root)=>{
    if(root.dataset.avInitialized)return;root.dataset.avInitialized="1";
    let cents=Number(root.dataset.avPriceCents||0), qty=Number(root.querySelector('[data-av-qty]:checked')?.value||1);
    let selectedVariant=root.querySelector('[data-av-variant-id]')?.value;
    let available=true;
    const upsell=root.querySelector('[data-av-upsell]');
    const upsellToggle=upsell?.querySelector('[data-av-upsell-toggle]');
    const upsellDetails=upsell?.querySelector('[data-av-upsell-details]');
    const upsellVariant=String(upsell?.dataset.avUpsellVariant||'');
    const upsellPrice=Math.max(0,Number(upsell?.dataset.avUpsellPrice||0));
    const upsellPercent=Math.max(0,Math.min(60,Number(upsell?.dataset.avUpsellDiscountPercent||0)));
    const upsellExactCents=Number(upsell?.dataset.avUpsellExactCents||0);
    const upsellCode=String(upsell?.dataset.avUpsellDiscountCode||'').trim();
    const upsellDealFor=(packs=1)=>{
      const count=Math.max(1,Math.min(3,Number(packs)||1));
      const regular=upsellPrice*count;
      const discountedUnit=(upsellExactCents>0 && upsellExactCents<upsellPrice)
        ? Math.round(upsellExactCents)
        : upsellPercent>0 ? Math.round(upsellPrice*(1-upsellPercent/100)) : upsellPrice;
      const total=discountedUnit*count;
      const saving=regular>0?Math.round((regular-total)*100/regular):0;
      return {regular,total,saving,hasDiscount:total<regular,code:upsellCode};
    };
    let upsellPacks=1;
    const upsellSelected=()=>Boolean(upsellToggle?.getAttribute('aria-pressed')==='true' && upsellVariant && upsellPrice>0);
    const suggestedPacks=()=>Math.max(1,Math.ceil(qty/2));
    const renderUpsell=()=>{
      if(!upsell)return;
      upsell.hidden=false;
      upsellPacks=Math.max(1,Math.min(qty,upsellPacks));
      const checked=upsellSelected();
      if(upsellDetails)upsellDetails.hidden=!checked;
      const count=upsell.querySelector('[data-av-upsell-count]');
      if(count)count.textContent=String(upsellPacks);
      const units=upsell.querySelector('[data-av-upsell-units]');
      if(units)units.textContent=(upsellPacks*2)+' power banks';
      const plus=upsell.querySelector('[data-av-upsell-plus]');
      const minus=upsell.querySelector('[data-av-upsell-minus]');
      if(plus)plus.disabled=upsellPacks>=qty;
      if(minus)minus.disabled=upsellPacks<=1;
      const deal=upsellDealFor(checked?upsellPacks:1);
      const line=upsell.querySelector('[data-av-upsell-line-price]');
      if(line)line.textContent='+ '+money(deal.total);
      const original=upsell.querySelector('[data-av-upsell-old-price]');
      if(original){original.hidden=!deal.hasDiscount;if(deal.hasDiscount)original.textContent=money(deal.regular);}
      const badge=upsell.querySelector('[data-av-upsell-save]');
      if(badge){badge.hidden=!deal.hasDiscount;if(deal.hasDiscount)badge.textContent='SAVE '+deal.saving+'%';}
    };
    const currency=root.dataset.avCurrency||'USD';
    let formatter;
    try{formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency})}
    catch(e){formatter=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'})}
    const money=v=>formatter.format(v/100);
    const activePack=()=>root.querySelector('[data-av-qty]:checked');
    const dealFor=(radio,unitCents=cents)=>{
      const quantity=Math.max(1,Math.min(3,Number(radio?.value||1)));
      const regular=Math.round(unitCents*quantity);
      const percent=Number(radio?.dataset.avDiscountPercent||0);
      const exact=Number(radio?.dataset.avExactCents||0);
      const code=String(radio?.dataset.avDiscountCode||'').trim();
      let total=regular;
      if(exact>0 && exact<regular){total=Math.round(exact);}
      else if(percent>0 && percent<=60){total=Math.round(regular*(1-percent/100));}
      const saving=regular>0&&total<regular ? Math.round((regular-total)*100/regular):0;
      return {quantity,regular,total,saving,hasDiscount:saving>0,code};
    };
    const form=root.querySelector('.avr-product-form');
    const submit=root.querySelector('[data-av-submit]');
    const feedback=root.querySelector('[data-av-feedback]');
    const repaint=()=>{
      renderUpsell();
      const selectedDeal=dealFor(activePack());
      const upsellDeal=upsellDealFor(upsellPacks);
      const addedPowerBanks=upsellSelected()?upsellDeal.total:0;
      const regularPowerBanks=upsellSelected()?upsellDeal.regular:0;
      const estimated=selectedDeal.total+addedPowerBanks;
      const compareUnit=Number(root.dataset.avCompareCents||0);
      const hasProductSale=!selectedDeal.hasDiscount && compareUnit>cents;
      const hasSale=selectedDeal.hasDiscount || hasProductSale || (upsellSelected() && upsellDeal.hasDiscount);
      const slippersOriginal=selectedDeal.hasDiscount ? selectedDeal.regular : (hasProductSale ? compareUnit*qty : selectedDeal.regular);
      const regularTotal=slippersOriginal+regularPowerBanks;
      const savingPercent=regularTotal>estimated?Math.round((regularTotal-estimated)*100/regularTotal):0;
      const unit=root.querySelector('[data-av-unit-price]');
      if(unit){unit.textContent=money(estimated);unit.classList.toggle('is-discounted',hasSale);}
      const original=root.querySelector('[data-av-top-original]');
      if(original){original.hidden=!hasSale;if(hasSale)original.textContent=money(regularTotal);}
      const badge=root.querySelector('[data-av-top-save]');
      if(badge){badge.hidden=!hasSale;if(hasSale)badge.textContent=(root.dataset.avSavePrefix||'Save')+' '+savingPercent+'%';}
      const caption=root.querySelector('[data-av-price-caption]');
      if(caption)caption.textContent=upsellSelected()
        ? 'Total for '+qty+' '+(qty===1?'pair':'pairs')+' + '+upsellPacks+' Power Bank '+(upsellPacks===1?'pack':'packs')
        : qty===1?(root.dataset.avUnitLabel||'per pair'):'total for '+qty+' pairs';
      root.querySelectorAll('.avr-bundle').forEach(label=>{
        const radio=label.querySelector('[data-av-qty]');
        const num=Number(radio?.value||1);
        const discount=dealFor(radio);
        const expected=discount.total;
        const baseCompare=Number(root.dataset.avCompareCents||0);
        const baseSale=!discount.hasDiscount && baseCompare>cents;
        const hasPackSale=discount.hasDiscount||baseSale;
        const originalAmount=discount.hasDiscount?discount.regular:baseCompare*num;
        const amountSaved=discount.hasDiscount?discount.saving:(baseSale?Math.round((baseCompare-cents)/baseCompare*100):0);
        label.classList.toggle('avr-bundle--deal',hasPackSale);
        const price=label.querySelector('[data-av-bundle-price]');
        if(price){price.textContent=money(expected);price.classList.toggle('is-discounted',hasPackSale);}
        const regular=label.querySelector('[data-av-bundle-regular]');
        if(regular){regular.hidden=!hasPackSale;regular.textContent=money(originalAmount);}
        const savings=label.querySelector('[data-av-bundle-savings]');
        if(savings){savings.hidden=!hasPackSale;if(hasPackSale)savings.textContent=(root.dataset.avSavePrefix||'Save')+' '+amountSaved+'%';}
      });
      const total=root.querySelector('[data-av-price-total]');if(total)total.textContent=money(estimated);
      const sticky=root.querySelector('[data-av-sticky-price]');if(sticky)sticky.textContent=money(estimated);
      const note=root.querySelector('[data-av-discount-note]');
      if(note){
        const baseNote=selectedDeal.hasDiscount?(root.dataset.avDealNote||'Discounted prices must match the active Shopify offer.'):(root.dataset.avRegularNote||'Totals before shipping.');
        note.textContent=baseNote+(upsellSelected()?' Includes '+(2*upsellPacks)+' power banks.':'')+(upsellSelected()&&upsellDeal.hasDiscount?' Power Bank savings require a matching Shopify discount at checkout.':'');
      }

      const inp=root.querySelector('[data-av-quantity]');if(inp)inp.value=String(qty);
      const inpID=root.querySelector('[data-av-variant-id]');if(inpID&&selectedVariant)inpID.value=selectedVariant;
      if(submit)submit.disabled=!available;
      const buyNow=root.querySelector('[data-av-buy-now]');
      if(buyNow){
        const rootPath=window.Shopify?.routes?.root||'/';
        const variant=selectedVariant||root.querySelector('[data-av-variant-id]')?.value;
        const base=rootPath+'cart/'+encodeURIComponent(variant||'')+':'+qty+(upsellSelected()?','+encodeURIComponent(upsellVariant)+':'+upsellPacks:'');
        const codes=[selectedDeal.code,upsellSelected()?upsellDeal.code:''].filter(Boolean);
        const uniqueCodes=[...new Set(codes)];
        const query=uniqueCodes.length?'?discount='+uniqueCodes.map(encodeURIComponent).join(','):'';
        buyNow.href=base+query;
        buyNow.setAttribute('aria-disabled',available?'false':'true');
        buyNow.classList.toggle('is-disabled',!available);
      }
    };
    root.querySelectorAll('[data-av-qty]').forEach(radio=>radio.addEventListener('change',()=>{
      qty=Number(root.querySelector('[data-av-qty]:checked')?.value||1);
      upsellPacks=suggestedPacks();
      repaint();
    }));
    root.querySelector('[data-av-variant]')?.addEventListener('change',e=>{
      const opt=e.target.selectedOptions?.[0];if(!opt)return;
      selectedVariant=opt.value;cents=Number(opt.dataset.price||cents);available=opt.dataset.stock==='true';repaint();
    });
    // Selection only — never submit a form or follow a link when choosing the add-on.
    upsellToggle?.addEventListener('click',(event)=>{
      event.preventDefault();
      event.stopPropagation();
      const isSelected=upsellToggle.getAttribute('aria-pressed')==='true';
      upsellToggle.setAttribute('aria-pressed',String(!isSelected));
      if(!isSelected)upsellPacks=suggestedPacks();
      repaint();
    });
    upsell?.querySelector('[data-av-upsell-minus]')?.addEventListener('click',(event)=>{
      event.preventDefault();event.stopPropagation();upsellPacks=Math.max(1,upsellPacks-1);repaint();
    });
    upsell?.querySelector('[data-av-upsell-plus]')?.addEventListener('click',(event)=>{
      event.preventDefault();event.stopPropagation();upsellPacks=Math.min(qty,upsellPacks+1);repaint();
    });
    upsell?.addEventListener('click',event=>event.stopPropagation());
    const main=root.querySelector('.avr-stage-img');
    const zoomImg=root.querySelector('[data-av-lightbox-img]');
    root.querySelectorAll('[data-av-thumb]').forEach(b=>b.addEventListener('click',()=>{
      root.querySelectorAll('[data-av-thumb]').forEach(n=>{n.classList.remove('is-current');n.setAttribute('aria-pressed','false')});
      b.classList.add('is-current');b.setAttribute('aria-pressed','true');
      if(main){main.src=b.dataset.image;main.srcset='';main.alt=b.dataset.alt||'AVERRO heated slippers'}
      if(zoomImg){zoomImg.src=b.dataset.image;zoomImg.alt=b.dataset.alt||'AVERRO heated slippers'}
    }));
    const dialog=root.querySelector('[data-av-lightbox]');
    root.querySelector('[data-av-zoom]')?.addEventListener('click',()=>{if(!dialog)return;
      if(zoomImg&&main){zoomImg.src=main.currentSrc||main.src;zoomImg.alt=main.alt}dialog.showModal?.()});
    root.querySelector('[data-av-close]')?.addEventListener('click',()=>dialog?.close());
    dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
    root.querySelector('[data-av-sticky-submit]')?.addEventListener('click',()=>{if(form){if(form.requestSubmit)form.requestSubmit();else submit?.click();}});
    if(form)form.addEventListener('submit',async(e)=>{
      if(!window.fetch)return;
      e.preventDefault();
      if(submit?.disabled)return;
      if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true')}
      if(feedback)feedback.textContent="Adding to cart…";
      try{
        const addUrl=(window.Shopify?.routes?.root||'/')+'cart/add.js';
        const cartOptions=upsellSelected()
          ? {method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},
             body:JSON.stringify({items:[
               {id:Number(selectedVariant||root.querySelector('[data-av-variant-id]')?.value),quantity:qty},
               {id:Number(upsellVariant),quantity:upsellPacks}
             ]})}
          : {method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}};
        const response=await fetch(addUrl,cartOptions);
        if(!response.ok){const data=await response.json().catch(()=>({}));throw Error(data.description||'Unable to add to cart')};
        const rootPath=window.Shopify?.routes?.root||'/';
        const cartUrl=rootPath+'cart';
        const chosenDeal=dealFor(activePack());
        // Shopify discount shareable links apply an existing code to the customer's cart.
        // The configured percentage must match the actual discount in Shopify Admin.
        const powerCode=upsellSelected()?upsellDealFor(upsellPacks).code:'';
        const discountCodes=[...new Set([chosenDeal.code,powerCode].filter(Boolean))];
        if(discountCodes.length===1){
          const discountUrl=rootPath+'discount/'+encodeURIComponent(discountCodes[0])+'?redirect='+encodeURIComponent(cartUrl);
          window.location.assign(discountUrl);
        }else if(discountCodes.length>1){
          // Shopify supports combined codes in cart permalink links.
          // For an existing AJAX cart, use the cart discount parameter so the
          // customer can verify the resulting checkout promotions.
          window.location.assign(cartUrl+'?discount='+discountCodes.map(encodeURIComponent).join(','));
        }else{
          window.location.assign(cartUrl);
        }
      }catch(error){
        if(feedback)feedback.textContent=error.message||'Could not add to cart. Please try again.';
        if(submit){submit.disabled=false;submit.removeAttribute('aria-busy')}
      }
    });
    // Hide sticky CTA while primary Add to Cart is in view.
    const sticky=root.querySelector('[data-av-sticky]');
    if(sticky&&submit&&'IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{
        const isVisible=entries.some(entry=>entry.isIntersecting);
        sticky.classList.toggle('is-hidden',isVisible);
        sticky.setAttribute('aria-hidden',isVisible?'true':'false');
      },{threshold:0.05,rootMargin:'0px 0px -5% 0px'});
      observer.observe(submit);
    }
    repaint();
  };
  const boot=()=>document.querySelectorAll('[data-av-rooog]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
